import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-team-captains-guide',
  templateUrl: './team-captains-guide.component.html',
  styleUrls: ['../participants-resources/participants-resources.scss']
})
export class TeamCaptainsGuideComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
